import { api } from './api';

export const plansApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPlans: builder.query({
      query: (params = {}) => ({
        url: '/admin/plans',
        params: {
          page: params.page ?? 1,
          limit: params.limit ?? 10,
          ...(params.search && { search: params.search }),
        },
      }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.map(({ id }) => ({ type: 'Plan', id })),
              { type: 'Plan', id: 'LIST' },
            ]
          : [{ type: 'Plan', id: 'LIST' }],
    }),
    getPlan: builder.query({
      query: (id) => ({ url: `/admin/plans/${id}` }),
      providesTags: (result, error, id) => [{ type: 'Plan', id }],
    }),
    createPlan: builder.mutation({
      query: (body) => ({
        url: '/admin/plans',
        method: 'POST',
        body,
      }),
      invalidatesTags: [{ type: 'Plan', id: 'LIST' }],
    }),
    updatePlan: builder.mutation({
      query: ({ id, ...body }) => ({
        url: `/admin/plans/${id}`,
        method: 'PATCH',
        body,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Plan', id }, { type: 'Plan', id: 'LIST' }],
    }),
    deletePlan: builder.mutation({
      query: (id) => ({
        url: `/admin/plans/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Plan', id }, { type: 'Plan', id: 'LIST' }],
    }),
  }),
});

export const {
  useGetPlansQuery,
  useGetPlanQuery,
  useCreatePlanMutation,
  useUpdatePlanMutation,
  useDeletePlanMutation,
} = plansApi;
